import { createActions } from 'redux-actions';


const actionCreators = createActions({
    ORGANIZATIONS: {
        DATA: {
            SET: data => data,
            RESET: undefined,
        },
    },
});

export default actionCreators.organizations;
